"use client";

import { trpcApi } from "@lattice/frontend/lib/trpc/client/index";

export default function StockTags({ symbol }: { symbol: string }) {
  const { data: tags } = trpcApi.stock.get_tags.useQuery({
    symbol,
  });

  // Default color fallback
  const defaultColor = "#6b7280";

  if (!tags || !tags.length) return null;

  return (
    <ul className="flex gap-2 overflow-x-auto scrollbar-none min-w-0">
      {tags.map((tag) => {
        const tagColor = tag.color || defaultColor;

        return (
          <li
            key={tag.label}
            className="flex items-center gap-2 px-2.5 py-1 rounded-lg backdrop-blur-sm shadow-sm text-xs font-medium whitespace-nowrap"
            style={{
              backgroundColor: `${tagColor}15`,
              borderWidth: "1px",
              borderColor: `${tagColor}30`,
            }}
          >
            <div
              className="w-2 h-2 rounded-full"
              style={{ backgroundColor: tagColor }}
            />
            <span style={{ color: tagColor }}>{tag.label}</span>
          </li>
        );
      })}
    </ul>
  );
}
